export function dataInRequest(params = {}) {
  return {
    type: '@notasFiscaisRecebidas/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@notasFiscaisRecebidas/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@notasFiscaisRecebidas/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@notasFiscaisRecebidas/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@notasFiscaisRecebidas/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@notasFiscaisRecebidas/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@notasFiscaisRecebidas/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@notasFiscaisRecebidas/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@notasFiscaisRecebidas/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@notasFiscaisRecebidas/RECORD_FILTERING',
    payload: { params },
  };
}
